{
  "alert.informative": "Informatief",
  "alert.negative": "Negatief",
  "alert.notice": "Kennisgeving",
  "alert.positive": "Positief",
  "attachmentlist.nextAttachments": "Volgende bijlagen weergeven",
  "attachmentlist.previousAttachments": "Vorige bijlagen weergeven",
  "chat.newMessage": "Nieuw bericht",
  "chat.scrollToBottom": "Naar beneden scrollen",
  "messagefeedback.thumbDown": "Slecht antwoord",
  "messagefeedback.thumbUp": "Goed antwoord",
  "promptfield.aiDisclaimer": "Reacties worden gegenereerd met AI en kunnen onnauwkeurig zijn. Controleer voor gebruik.",
  "promptfield.aiUserGuidlines": "AI-gebruikersrichtlijnen",
  "promptfield.attachments": "Bijlagen",
  "promptfield.insertButton": "Toevoegen",
  "promptfield.label": "Opdracht",
  "promptfield.placeholder": "Klaar om aan de slag te gaan? Stel een vraag, deel een idee of voeg een taak toe.",
  "promptfield.placeholder.small": "Stel een vraag",
  "promptfield.stopButton": "Stoppen",
  "promptfield.submitButton": "Verzenden",
  "promptfield.uploading": "Uploaden",
  "responsestatus.loading": "Laden",
  "responsestatus.processing": "Verwerken...",
  "voicebutton.startListening": "Opname starten",
  "voicebutton.stopListening": "Opname stoppen"
}
